module.exports = __webpack_public_path__ + "img/vuesax-login-bg3.2770e5c5.jpg";